import React, { useState, useEffect, useContext } from "react";
import { useParams, useHistory } from "react-router";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";

import CreatableSelect from "react-select/creatable";

import Loader from "../../components/Loader";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import useEditUser from "../../mutation/user/updateUser";
import useManagers from "../../queries/user/getManagers.js";
import useSuperAdmins from "../../queries/user/getUsers.js";
import useGetUser from "../../queries/user/getUser";
import autoGenerate from "../../utils/autoGenerate";
import { AuthContext } from "../../utils/userProvider";
import {
  FormPageShell,
  FormPageCard,
  FormPageHeader,
  FormActions,
} from "../../components/ListPage";

const schema = yup.object().shape({
  username: yup.string().required("Username is required"),
  password: yup.string(),
  email: yup.string().required("Email is required"),
  accessRole: yup.object().required("An Access Role must be selected."),
});

const EditUser = (props) => {
  const { id } = useParams();
  const history = useHistory();

  const [response, setResponse] = useGetUser(id);
  const { authState, setAuthState } = useContext(AuthContext);
  const [managerRespose, setManagerResponse] = useManagers();
  const [superAdminResponse, setSuperAdminResponse] = useSuperAdmins();

  const [updateResponse, setData] = useEditUser(id);

  const [defaultRoleValue, setDefaultRoleValue] = useState();
  const [defaultTabAcessValue, setDefaultTabAccess] = useState();
  const [defaultUsername, setDefaultUsername] = useState();
  const [defaultEmail, setDefaultEmail] = useState();
  const [defaultManager, setDefaultManager] = useState();
  const [defaultSuperAdmin, setDefaultSuperAdmin] = useState();

  const [accessRoleOptions, setAccessRoleOptions] = useState([
    { label: "Manager", value: "Manager" },
    { label: "Executive", value: "Executive" },
  ]);

  const tabAccessOptions = [
    { label: "City", value: "city" },
    { label: "Property", value: "property" },
    { label: "Room Types", value: "roomtypes" },
    { label: "Add-ons", value: "addons" },
    { label: "Agents", value: "agent" },
    { label: "Active Transactions", value: "transactions" },
    { label: "Expired Transactions", value: "expiredTransactions" },
    { label: "Promotions", value: "promotions" },
    { label: "Rate Nunbers", value: "rate-numbers" },
    { label: "Gifts", value: "gifts" },
    { label: "Credit Notes", value: "creditnote" },
    { label: "Stripe Fees", value: "stripefees" },
    { label: "Users", value: "users" },
    { label: "Pending Audits", value: "pending-audits" },
    { label: "Approved Audits", value: "approved-audits" },
    { label: "Rejected Audits", value: "rejected-audits" },
    { label: "System Settings", value: "system-setting" },
    { label: "Account Settings", value: "setting" },
  ];

  const [managerOptions, setManagerOptions] = useState([]);
  const [superAdminOptions, setSuperAdminOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState();

  const accessRoleChange = (value) => {
    setValue("accessRole", value);
    setSelectedRole(value.value);
  };

  const managerChange = (value) => {
    setValue("manager", value);
  };

  const superAdminChange = (value) => {
    setValue("superadmin", value);
  };
  const { control, register, handleSubmit, setValue, errors, setError } =
    useForm({
      resolver: yupResolver(schema),
    });

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  useEffect(() => {
    if (authState.role == "Executive") {
      history.push("/dashboard/roomtypes");
    }
    if (authState.role == "Manager") {
      setAccessRoleOptions([{ label: "Executive", value: "Executive" }]);
    }
  }, [authState]);

  useEffect(() => {
    let managerOptions = [],
      superAdminOptions = [];
    if (managerRespose.data && superAdminResponse.data && response.data) {
      if (managerRespose.data) {
        //setup options
        let data = managerRespose.data;
        for (var i = 0; i < data.length; i++) {
          let manager = data[i];
          if (manager.email != response.data.email) {
            managerOptions.push({
              label: manager.email,
              value: manager.id,
            });
          }
        }

        setManagerOptions(managerOptions);
      }
      if (superAdminResponse.data) {
        //setup options
        let data = superAdminResponse.data;
        for (var i = 0; i < data.length; i++) {
          let SuperAdmin = data[i];
          if (SuperAdmin.accessRole == "SuperAdmin") {
            if (SuperAdmin.email != response.data.email) {
              superAdminOptions.push({
                label: SuperAdmin.email,
                value: SuperAdmin.id,
              });
            }
          }
        }
        setSuperAdminOptions(superAdminOptions);
      }
      if (response.data) {
        console.log(response.data);
        setValue("username", response.data.username);
        setDefaultUsername(response.data.username);
        setValue("email", response.data.email);
        setDefaultEmail(response.data.email);
        let roleObj = {
          label: response.data.accessRole,
          value: response.data.accessRole,
        };
        setValue("accessRole", roleObj);
        setSelectedRole(roleObj.value);
        let tabAccess = tabAccessOptions.filter((x) =>
          response.data.tabAccess.includes(x.value)
        );
        setValue("tabAccess", tabAccess);
        setDefaultTabAccess(tabAccess);
        setDefaultRoleValue(roleObj);
        if (roleObj.value == "Executive") {
          let managerObj = managerOptions.find(
            (x) => x.value == response.data.Manager
          );
          if (managerObj) {
            setDefaultManager(managerObj);
            setValue("manager", managerObj);
          }
          let superAdmin = superAdminOptions.find(
            (x) => x.value == response.data.SuperAdmin
          );
          if (superAdmin) {
            setDefaultSuperAdmin(superAdmin);
            setValue("superadmin", superAdmin);
          }
        }
      }
    }

    console.error(response.data);
  }, [response, managerRespose, superAdminResponse]);

  const goBack = () => {
    window.location.href = "/dashboard/users";
  };

  const autoGeneratePassword = () => {
    setValue("password", autoGenerate(6));
  };

  const tabAccessChange = (value) => {
    setValue("tabAccess", value);
  };

  const onSubmit = (values) => {
    values.accessRole = values.accessRole.value;
    let tabAccess = [];
    if (values.tabAccess) {
      for (var i = 0; i < values.tabAccess.length; i++) {
        tabAccess.push(values.tabAccess[i].value);
      }
      values.tabAccess = tabAccess;
    }
    if (values.accessRole == "Executive") {
      let pass = true;
      if (!values.superadmin && authState.accessRole == "Manager") {
        setError("superadmin", "A SuperAdmin must be selected");
        pass = false;
      }
      if (!values.manager && authState.accessRole == "SuperAdmin") {
        setError("manager", "A Manager must be selected");
        pass = false;
      }
      if (pass) {
        if (values.superadmin) {
          values.superadmin = values.superadmin.value;
        }
        if (values.manager) {
          values.manager = values.manager.value;
        }
        setData(values);
      }
    } else {
      setData(values);
    }
  };

  useEffect(() => {
    try {
      if (updateResponse.data) {
        Toast.fire({
          icon: "success",
          title: "User updated",
        });
        history.push("/dashboard/users");
      } else if (updateResponse.error) {
        let data = updateResponse.errorMessage.response.data;
        if (data) {
          let messageData = data.message;
          let message = messageData.message;
          Swal.fire({
            icon: "error",
            title: "Error",
            text: message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: updateResponse.error.message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [updateResponse]);

  const fieldLabelSx = { fontSize: 16, fontWeight: "bold", mt: 2, mb: 1 };
  const validationSx = {
    ml: 1.75,
    mr: 1.75,
    mt: 0.625,
    fontSize: "0.75rem",
    color: "secondary.main",
  };

  const renderContent = () => {
    return (
      <FormPageShell>
        <Box
          component="form"
          noValidate
          onSubmit={handleSubmit(onSubmit)}
        >
          <Stack spacing={2}>
            <FormPageCard>
              <FormPageHeader
                title="Edit User"
                onBack={goBack}
                subtitle="Please fill in the required fields."
              />
              <TextField
                name="username"
                margin="normal"
                fullWidth
                label="Username*"
                variant="outlined"
                inputRef={register}
                defaultValue={defaultUsername ? defaultUsername : null}
                error={errors.name != null}
                helperText={errors.name != null ? errors.name.message : null}
                disabled={updateResponse.loading}
              />
              <TextField
                name="email"
                margin="normal"
                fullWidth
                label="Email*"
                variant="outlined"
                inputRef={register}
                defaultValue={defaultEmail ? defaultEmail : null}
                error={errors.name != null}
                helperText={errors.name != null ? errors.name.message : null}
                disabled={updateResponse.loading}
              />
              <TextField
                name="password"
                margin="normal"
                fullWidth
                label="Password (Leave empty to not edit)"
                variant="outlined"
                inputRef={register}
                error={errors.name != null}
                helperText={errors.name != null ? errors.name.message : null}
                disabled={updateResponse.loading}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="auto-generate-password"
                        onClick={autoGeneratePassword}
                      >
                        <CachedIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Typography sx={fieldLabelSx}>Tab Access</Typography>
              {tabAccessOptions.length > 0 && defaultTabAcessValue != null && (
                <Box>
                  <Controller
                    name="tabAccess"
                    control={control}
                    defaultValue={
                      defaultTabAcessValue ? defaultTabAcessValue : null
                    }
                    render={({ ...props }) => {
                      return (
                        <CreatableSelect
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              borderColor: errors.tabAccess
                                ? "red"
                                : provided.borderColor,
                            }),
                          }}
                          isMulti
                          defaultValue={
                            defaultTabAcessValue ? defaultTabAcessValue : null
                          }
                          options={tabAccessOptions}
                          onChange={tabAccessChange}
                          disabled={updateResponse.loading}
                        />
                      );
                    }}
                  />
                  {errors.tabAccess && <Box>{errors.tabAccess.message}</Box>}
                </Box>
              )}
              {accessRoleOptions.length > 0 && defaultRoleValue != null && (
                <Box>
                  <Typography sx={fieldLabelSx}>Access Role</Typography>
                  <Controller
                    name="accessRole"
                    control={control}
                    defaultValue={defaultRoleValue ? defaultRoleValue : null}
                    render={({ ...props }) => {
                      return (
                        <CreatableSelect
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              borderColor: errors.room_types
                                ? "red"
                                : provided.borderColor,
                            }),
                          }}
                          defaultValue={
                            defaultRoleValue ? defaultRoleValue : null
                          }
                          options={accessRoleOptions}
                          onChange={accessRoleChange}
                          disabled={updateResponse.loading}
                        />
                      );
                    }}
                  />
                  {errors.accessRole && (
                    <Box sx={validationSx}>{errors.accessRole.message}</Box>
                  )}
                </Box>
              )}
              {selectedRole == "Executive" && authState.role == "SuperAdmin" && (
                <Box>
                  <Typography sx={fieldLabelSx}>Supervising Manager</Typography>
                  <Controller
                    name="manager"
                    control={control}
                    defaultValue={defaultManager ? defaultManager : null}
                    render={({ ...props }) => {
                      return (
                        <CreatableSelect
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              borderColor: errors.room_types
                                ? "red"
                                : provided.borderColor,
                            }),
                          }}
                          defaultValue={
                            defaultManager ? defaultManager : null
                          }
                          options={managerOptions}
                          onChange={managerChange}
                          disabled={updateResponse.loading}
                        />
                      );
                    }}
                  />
                  {errors.manager && (
                    <Box sx={validationSx}>{errors.manager.message}</Box>
                  )}
                </Box>
              )}
              {selectedRole == "Executive" && authState.role == "Manager" && (
                <Box>
                  <Typography sx={fieldLabelSx}>
                    Supervising Super Admin
                  </Typography>
                  <Controller
                    name="superadmin"
                    control={control}
                    defaultValue={
                      defaultSuperAdmin ? defaultSuperAdmin : null
                    }
                    render={({ ...props }) => {
                      return (
                        <CreatableSelect
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              borderColor: errors.room_types
                                ? "red"
                                : provided.borderColor,
                            }),
                          }}
                          defaultValue={
                            defaultSuperAdmin ? defaultSuperAdmin : null
                          }
                          options={superAdminOptions}
                          onChange={superAdminChange}
                          disabled={updateResponse.loading}
                        />
                      );
                    }}
                  />
                  {errors.superadmin && (
                    <Box sx={validationSx}>{errors.superadmin.message}</Box>
                  )}
                </Box>
              )}
            </FormPageCard>
            <FormPageCard>
              <FormActions>
                <Button
                  type="submit"
                  size="large"
                  variant="contained"
                  color="primary"
                  disabled={updateResponse.loading}
                >
                  Submit
                </Button>
              </FormActions>
            </FormPageCard>
          </Stack>
        </Box>
      </FormPageShell>
    );
  };

  return (
    <Box>
      {response.loading &&
        managerRespose.loading &&
        superAdminResponse.loading && (
          <FormPageCard>
            <Loader />
          </FormPageCard>
        )}
      {!response.loading &&
        !managerRespose.loading &&
        !superAdminResponse.loading &&
        renderContent()}
    </Box>
  );
};

export default EditUser;
